export default __webpack_public_path__ + "static/media/body-section-hamstrings.cddc622d.png";